import { useRef, useEffect } from "react";

export function useInitialMountStatus() {
  const initialMount = useRef(true);
  useEffect(() => {
    initialMount.current = false;
  }, []);
  return initialMount.current;
}
